import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_IS_FILE_UPLOAD_STARTED = `${PhotoCapture.PHOTO_CAPTURE}_IS_FILE_UPLOAD_STARTED`;
export const photoCaptureIsFileUploadStartedAction = isFileUploadStarted => ({
    type: PHOTO_CAPTURE_IS_FILE_UPLOAD_STARTED,
    payload: isFileUploadStarted
});
//# sourceMappingURL=photoCaptureIsFileUploadStartedAction.js.map